import { render, staticRenderFns } from "./simplifyOwnerRooms.vue?vue&type=template&id=a507a8b6&scoped=true"
import script from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerRooms.vue?vue&type=style&index=0&id=a507a8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a507a8b6",
  null
  
)

export default component.exports